module.exports = __webpack_public_path__ + "img/hashtags.343bd83e.png";